import { Backdrop, CircularProgress } from '@mui/material';

import { useLoader } from 'contexts/LoaderContext';

export const Loader = ({ isLoading = true }) => (
  <Backdrop sx={{ zIndex: 1301, color: '#fff' }} open={isLoading}>
    <CircularProgress />
  </Backdrop>
);

const ApiLoader = () => {
  const { isLoading } = useLoader();

  return <Loader isLoading={isLoading} />;
};

export default ApiLoader;
